import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JQueryHTTPClient } from 'app/rest/JQueryHTTPClient';
import { EntityService } from 'app/rest/entity.service';
import { Rest } from 'app/rest/rest_client';


@Injectable({
	providedIn: 'root'
 })
export class RenewalFilesService extends EntityService<Rest.RenewalFiles> {
	client: Rest.RestApplicationClient;

	constructor(private jquery: JQueryHTTPClient,private http: HttpClient) {
		super();
		this.client = new Rest.RestApplicationClient(jquery);
	  }

	getPage(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest.RenewalFiles>> {
        return this.client.RenewalFiles_getPage(arg0);
    }
}